/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useEffect, useState } from 'react'
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

const EducatorVisitListTable = ({ visitList, options, getIndex, getPatientOutClass, taskScreen, getOutClass, tagsContent, nameContent, get_age_by_dob, isApp, action }) => {
  //console.log(visitList,"0000000")
  return (

    <div className="visit-list min-hieght table-width">
      <BootstrapTable
        data={visitList}
        search={true}
        multiColumnSearch={true}
        options={options}
        striped
        hover
        condensed
      >
        <TableHeaderColumn
          hidden={true}
          tdAttr={{ "data-attr": "id" }}
          dataField="id"
          dataSort={true}
          isKey
          searchable={false}
        >
          Id
        </TableHeaderColumn>

        <TableHeaderColumn
          thStyle={{ width: "5%" }}
          tdStyle={{ width: "5%" }}
          tdAttr={{ "data-attr": "#" }}
          dataField="sn"
          dataFormat={getIndex}
          columnClassName={getPatientOutClass}
        >
          #
        </TableHeaderColumn>

        <TableHeaderColumn
          thStyle={{ width: "10%" }}
          tdStyle={{ width: "10%", whiteSpace: "nowrap" }}
          tdAttr={{ "data-attr": "PATIENT ID" }}
          dataField="patientId"
          dataFormat={taskScreen}
          columnClassName={getOutClass}
        >
          Patient ID
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={{ width: "20%" }}
          tdStyle={{ width: "20%" }}
          tdAttr={{ "data-attr": "NAME" }}
          dataField="name"
          dataFormat={nameContent}
        >
          Name
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={{ width: "5%" }}
          tdStyle={{ width: "5%" }}
          tdAttr={{ "data-attr": "AGE" }}
          dataField=""
          dataFormat={get_age_by_dob}
        >
          Age
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={{ width: "15%" }}
          tdStyle={{ width: "15%" }}
          tdAttr={{ "data-attr": "CITY" }}
          dataField="city"
        >
          City
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={{ width: "30%", fontWeight: "600" }}
          tdStyle={{ width: "30%", fontWeight: "600" }}
          tdAttr={{ "data-attr": "NAME" }}
          dataField="name"
          dataFormat={tagsContent}
        >
          Labels
        </TableHeaderColumn>

        <TableHeaderColumn
          thStyle={{ width: "5%" }}
          tdStyle={{ width: "5%" }}
          tdAttr={{ "data-attr": "APP" }}
          dataField=""
          dataFormat={isApp}
        >
          App
        </TableHeaderColumn>

        {/* <TableHeaderColumn thStyle={{ width: '100px' }} tdStyle={{ width: '100px' }} tdAttr={{ 'data-attr': 'Diet' }} dataField='' dataFormat={this.dietDetail.bind(this)}>Diet</TableHeaderColumn> */}
        {/* 
                            <TableHeaderColumn thStyle={{ width: '30px' }} tdStyle={{ width: '30px' }} tdAttr={{ 'data-attr': 'Rx' }} dataField='' dataFormat={this.emr.bind(this)}>Rx</TableHeaderColumn>

                            <TableHeaderColumn thStyle={{ width: '90px' }} tdStyle={{ width: '90px' }} tdAttr={{ 'data-attr': 'Password' }} dataField='' dataFormat={this.password.bind(this)}>Password</TableHeaderColumn>
                            
                             <TableHeaderColumn thStyle={{ width: '125px' }} tdStyle={{ width: '125px' }} tdAttr={{ 'data-attr': 'NEXT V' }} dataField='' dataFormat={this.nextButton.bind(this)}>Next Visit</TableHeaderColumn>
                            <TableHeaderColumn thStyle={{ width: '41px' }} tdStyle={{ width: '41px' }} tdAttr={{ 'data-attr': 'OUT' }} dataField='' dataFormat={this.outButton.bind(this)}>Out</TableHeaderColumn> */}

        <TableHeaderColumn
          thStyle={{ width: "10%" }}
          tdStyle={{ width: "10%" }}
          dataFormat={action}
        >
          Action
        </TableHeaderColumn>
      </BootstrapTable>
    </div>
  )
}

export default EducatorVisitListTable